import styled from "styled-components";

export const Styles = styled.div`
  padding: 20px;
  font-family: "Yu Gothic", "Hiragino Sans", "Hiragino Kaku Gothic ProN",
    "Noto Sans JP", "Meiryo", -apple-system, BlinkMacSystemFont, sans-serif;
  background: white;
  color: #333;

  /* Force all children to inherit the Japanese-capable font */
  * {
    font-family: inherit !important;
  }

  /* Centered title - full page width */
  .contract-title {
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    margin: 0 auto 30px;
    padding-bottom: 10px;
    border-bottom: none;
    color: #000;
    width: 100%;
  }

  /* Ensure PDF looks exactly like the screen */
  .ant-form {
    .ant-form-item {
      margin-bottom: 16px;
    }
  }

  /* Table hack for repeating top margins without browser headers */
  .pdf-print-table {
    width: 100%;
    border-collapse: collapse;
    border: none;
  }
  .pdf-print-table > thead > tr > td,
  .pdf-print-table > tbody > tr > td {
    padding: 0;
    border: none;
  }
  .pdf-print-header-space {
    height: 15mm;
  }

  /*
   * Override TextToolTip truncation for PDF rendering.
   * TextToolTip uses overflow:hidden + text-overflow:ellipsis + white-space:nowrap
   * which clips Japanese labels when container width is small (grid-based layout).
   * In PDF mode we need to show full text.
   */
  .label_container {
    min-height: 40px;
    margin-top: 10px;
    display: flex;
    align-items: center;
  }

  .layout-grid-item div {
    overflow: visible !important;
    text-overflow: unset !important;
    white-space: normal !important;
    word-break: keep-all !important;
  }

  /* Keep input/select/picker elements styled normally */
  .ant-input,
  .ant-select,
  .ant-select-selector,
  .ant-picker,
  .ant-picker-input,
  .ant-form-item-control-input,
  .ant-radio-group,
  .ant-checkbox-group {
    overflow: hidden !important;
    white-space: nowrap !important;
  }

  /* Signature section - ensure labels visible */
  .signed_info_grid {
    &__label,
    &__value {
      overflow: visible !important;
      white-space: normal !important;
    }
  }

  /* ===== HIDE: Buttons, action panels ===== */
  button,
  .ant-btn,
  .button,
  .button-collapse,
  .action-buttons-container,
  .action_cell {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
    padding: 0 !important;
    margin: 0 !important;
    border: none !important;
    opacity: 0 !important;
  }

  /* ===== HIDE: Table headers (項目, 条項 row) ===== */
  .table-div__header,
  .table-div__cell_header,
  .table-div__cell_header_inner {
    display: none !important;
    height: 0 !important;
    width: 0 !important;
    padding: 0 !important;
    margin: 0 !important;
    border: none !important;
    opacity: 0 !important;
    visibility: hidden !important;
    background: transparent !important;
  }

  /* ===== HIDE: Table Title and Empty Icon ===== */
  .is-table > div:first-child,
  .ant-empty {
    display: none !important;
  }

  /* ===== HIDE: The empty "header" row above real data ===== */
  /* If a table has multiple rows (ghost row + data row), hide the first ghost row */
  .table-div__body > *:first-child:not(:last-child) {
    display: none !important;
  }

  /* ===== HIDE: Horizontal scroll in tables ===== */
  .row_scroll {
    display: none !important;
  }

  /* ===== HIDE: Table outer borders but style cells like disabled inputs ===== */
  .table-div,
  .table-div__body,
  .table-div__row,
  .is-table,
  .layout-grid-item.is-table {
    border: none !important;
    border-width: 0 !important;
    box-shadow: none !important;
    outline: none !important;
    background: transparent !important;
  }

  /* Force tables and rows in PDF to take full width and give rows a minimum height */
  .table-div,
  .table-div__row {
    width: 100% !important;
    height: auto !important;
  }
  .table-div__row {
    min-height: 42px !important;
    align-items: stretch !important;
  }

  /* Style cells with gray background and white borders so they don't stick together */
  .table-div__cell {
    border: 3px solid white !important;
    background-color: #f5f5f5 !important;
    min-height: 42px !important;
    height: auto !important;
    border-radius: 6px !important;
    padding: 8px 12px !important;
    box-shadow: none !important;
    outline: none !important;
  }

  .ant-input,
  .ant-input-textarea,
  textarea,
  .ant-select,
  .ant-select-selector,
  .ant-picker,
  .ant-picker-input,
  .ant-form-item-control-input,
  .ant-form-item-control-input-content {
    height: auto !important;
    min-height: 32px;
    white-space: normal !important;
    word-break: break-word !important;
    overflow: visible !important;
  }

  textarea {
    field-sizing: content !important;
  }

  /* Keep other elements styled normally but allow wrap */
  .ant-radio-group,
  .ant-checkbox-group {
    overflow: visible !important;
    white-space: normal !important;
  }

  /* ===== HIDE: Pulldown arrows / suffix icons ===== */
  .ant-select-arrow,
  .ant-select-suffix,
  .ant-select-arrow-icon,
  .ant-picker-suffix,
  .ant-picker-clear,
  svg[class*="arrow"],
  svg[class*="down"] {
    display: none !important;
    opacity: 0 !important;
    visibility: hidden !important;
  }

  /* ===== HIDE: Scrollbars ===== */
  *::-webkit-scrollbar {
    display: none !important;
  }
  * {
    scrollbar-width: none !important;
    -ms-overflow-style: none !important;
  }

  /* Page break for printing */
  @media print {
    .ant-form .ant-form-item {
      margin-bottom: 10px !important;
    }

    .label_container {
      min-height: 24px !important;
      margin-top: 4px !important;
    }

    .contract-title {
      page-break-after: avoid;
      break-after: avoid;
    }
  }
`;
